import type { Product } from "@/features/inventory/types";
import type { Supplier } from "@/features/suppliers/types";

// BLU-271: match tier for the soft supplier sort/badge in SubmitOrderTab.
// 0 = the SKU's resolved effective supplier (sku.supplier_id ?? category
// default) is an exact-ID match with the PO's selected supplier; 1 = matches
// the category's backup supplier instead; 2 = no match (still shown, just
// sorted last and badged). Replaces the old `matchesSupplierProduct` free-text
// matcher (supplier.products fuzzy label matching), which excluded
// non-matching SKUs outright and could false-negative/false-positive on
// category-vs-supplier-label spelling drift.
export const SUPPLIER_MATCH_TIER = { exact: 0, backup: 1, none: 2 } as const;

export const getSupplierMatchTier = (product: Product, supplier: Supplier | null): number => {
  if (!supplier) return SUPPLIER_MATCH_TIER.none;
  if (product.effectiveSupplierId && product.effectiveSupplierId === supplier.id) {
    return SUPPLIER_MATCH_TIER.exact;
  }
  if (product.backupSupplierId && product.backupSupplierId === supplier.id) {
    return SUPPLIER_MATCH_TIER.backup;
  }
  return SUPPLIER_MATCH_TIER.none;
};
